import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import config from '@/config';
const { API_URL } = config;

export const fetchCompany = createAsyncThunk('company/fetch', async (paginationParams) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/company?${new URLSearchParams(paginationParams).toString()}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const data = await response.json();
  return data;
});

export const fetchAllCompany = createAsyncThunk('company/fetchAll', async () => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/company?all=true`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const data = await response.json();
  return data;
});

const companySlice = createSlice({
  name: 'company',
  initialState: {
    items: [],
    counts: 0,
    status: 'idle',
    error: null,
    allCompany: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompany.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCompany.fulfilled, (state, action) => {
        if (action.payload.code === 200) {
          state.status = 'succeeded';
          state.items = action.payload?.data?.items ?? [];
          state.counts = action.payload?.data?.counts ?? 0;
          state.error = null;
        } else {
          state.status = 'failed';
          state.error = action.payload.message;
        }
      })
      .addCase(fetchCompany.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchAllCompany.fulfilled, (state, action) => {
        if (action.payload.code === 200) {
          state.allCompany = action.payload?.data?.items ?? [];
        } else {
          state.allCompany = [];
          console.log('Помилка завантаження всих компаній.', action.payload.message);
        }
      });
  },
});

export default companySlice.reducer;
